export const endpoints = {
  getUser: () => ({
    url: 'v1/prizes/user',
  }),
  updateDailyModalState: () => ({
    url: 'v1/prizes/user/update-daily-modal-state',
  }),
  updateRatingResultsModalState: () => ({
    url: 'v1/prizes/user/update-rating-results-modal-state',
  }),
  updatePromoModalState: () => ({
    url: 'v1/prizes/user/update-promo-modal-state',
  }),
  catchPrize: () => ({
    url: 'v1/prizes/wheel/spin',
  }),
  getPrizes: () => ({
    url: 'v1/prizes/wheel/available-prizes',
  }),
  getGameConfiguration: () => ({
    url: 'v1/prizes/gameconfiguration/get-game-configuration',
  }),
  getLeaderboardCurrent: () => ({
    url: 'v1/prizes/leaderboard/current',
  }),
  getLeaderboardPrevious: () => ({
    url: 'v1/prizes/leaderboard/previous',
  }),
  getLeaderboardMyPositions: () => ({
    url: 'v1/prizes/leaderboard/my-positions',
  }),
}
